export default "__VITE_ASSET__CvSEgJDT__"